import type { AIDTColor } from './_typing';

export const purple: AIDTColor = Object.freeze({
  50: '#F1EEFA',
  100: '#E2DDEF',
  200: '#C5BBDF',
  300: '#A899CF', // cs elementary key
  400: '#8B77BF',
  500: '#6E55AF', //cs middle key
  600: '#6147AA',
  700: '#553AA5',
  800: '#482CA0',
  900: '#3C1E9B', //cs high bg
  950: '#281467',
  0: '#140A34', // cs high key
} as const);
